import { render } from "./Contact.vue?vue&type=template&id=389e4eb4"
const script = {}

import exportComponent from "/Users/elschubi/_development/_vue/projects/faszl-gfk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__